import React from 'react'

export function Factory({ as = 'div', children, ...props }: any) {
  return React.createElement(as, props, children)
}
